export const COMPANY = {
  brand: "Les Jardiniers Normands",
  subBrand: "Pro Élagage 14",
  phone: "07 80 04 43 90",
  phoneRaw: "+33780044390",
  email: "schmittantony4@gmail.com",
  address: "13 rue des Quatre Vents, 14000 Caen",
  streetAddress: "13 rue des Quatre Vents",
  city: "Caen",
  postalCode: "14000",
  region: "Normandie",
  department: "Calvados (14)",
  hours: "Lun-Sam : 8h00 – 20h00",
  whatsapp: "+33780044390",
  logos: {
    jardiniers: "https://lesjardiniersnormands.com/logo-les-jardiniers-normands-192.webp",
    proElagage: "https://lesjardiniersnormands.com/logo-pro-elagage-14-192.webp",
  },
  social: {
    gbp: "https://www.google.com/maps/place/?q=place_id:ChIJT3aLzJpS6QwRcdAARNmjOvE",
    gbpElagage: "https://www.google.com/maps/place/?q=place_id:ChIJt1gPdTigaQoRM3upIZQ0Ow4",
    google: "https://www.google.com/search?q=pro+%C3%A9lagage+14",
    reviewLink: "https://search.google.com/local/writereview?placeid=ChIJT3aLzJpS6QwRcdAARNmjOvE",
  },
  site: "https://lesjardiniersnormands.com",
  legal: {
    name: "Schmitt Antony",
    form: "Entreprise individuelle",
    siret: "891 548 802 00026",
    tva: "FR40 891 548 802",
    publisher: "Antony Schmitt",
  },
};
